module.exports = new __parcel__URL__("base_raid_button_text.b05d3662.png").toString();